import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Login from './components/Login';
import CreateAccount from './components/CreateAccount';
import store from './slices/store';
import PasswordReset from './components/PasswordReset';
import { PasswordPolicy } from './slices/types';

declare global {
    interface Window {
        EMAIL: string;
        CODE: string;
        HAS_VERIFIED: boolean;
        ERROR_MESSAGE: string;
        PASSWORD_POLICY: PasswordPolicy;
    }
}

const theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@keyframes autofill': {
                    '0%': { background: 'transparent' },
                    '100%': { background: 'transparent' },
                },
                'input:-webkit-autofill': {
                    animationName: 'autofill',
                    animationFillMode: 'both',
                    WebkitTextFillColor: 'white !important',
                    backgroundColor: 'transparent !important',
                    WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: { textTransform: 'none' },
            },
        },
    },
});

const router = createBrowserRouter([
    { path: '/login', element: <Login /> },
    { path: '/create', element: <CreateAccount /> },
    { path: '/password', element: <PasswordReset /> },
    { path: '/password/:payload', element: <PasswordReset /> },
]);

const container = document.getElementById('login-root');
if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
        </ThemeProvider>
    );
}
